import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService, IAppSettings } from '../../../services/configuration/configuration.service';
import { NotificationMessage } from '../notifications.model';
import { NotificationsTrayModel } from './notifications-tray.model';
import { NotificationsTrayService } from './notifications-tray.service';

@Component({
  selector: 'oir-notifications-tray',
  templateUrl: './notifications-tray.component.html',
  styleUrls: ['./notifications-tray.component.less']
})
export class NotificationsTrayComponent implements OnChanges, OnInit {
  public model$: Observable<NotificationsTrayModel>;
  public language: string;

  constructor(
    private configurationService: ConfigurationService<IAppSettings>,
    private notificationsTrayService: NotificationsTrayService
  ) {}

  ngOnInit(): void {
    this.language = this.configurationService.getCookie('lang');
    this.model$ = this.notificationsTrayService.trayModel;
    this.notificationsTrayService.getNotifications().subscribe();
  }

  // Detect changes on input lang
  ngOnChanges(changes: SimpleChanges): void {
    // Update language property with new value
    this.language = changes.lang.currentValue;
  }

  public dismiss(message: NotificationMessage): void {
    this.notificationsTrayService.dismiss(message).subscribe(() => {
      this.toggle();
    });
  }

  public dismissAll(): void {
    this.notificationsTrayService.dismissAll().subscribe(() => {
      this.toggle();
    });
  }

  public read(message: NotificationMessage): void {
    this.notificationsTrayService.read(message).subscribe(() => {
      this.toggle();
    });
  }

  public toggle(): void {
    this.notificationsTrayService.toggle();
  }

  anchorLinkAction(event, index): void {
    if (event.which === 13 || event.which === 32) {
      const element: HTMLElement = document.getElementsByClassName(
        'anchorNotificationPath'
      )[index] as HTMLElement;
      element.click();
    }
  }

  quoteReplace(text: string): string {
    return text.replace(/&quot;/g, '"');
  }
}
